import React from "react"
import { navigate } from "gatsby"
import { socialsArray } from "../../utilities/socials"
import "./footer.scss"

const Footer = () => {
  const goToSocial = (e) => {
    const index = e.currentTarget.dataset.index
    const link = socialsArray[index].link
    console.log("link", link)
    navigate(link)

  }
  return (
    <footer className="footer">
      <div>
        <p>+33 6 68 47 77 56</p>
      </div>
      <div>
        {
          socialsArray.map((social, si) => <button
              key={social.key}
              className="footer__button"
              data-index={si}
              onClick={goToSocial}
            >
              {social.tag}
            </button>
          )
        }
      </div>
    </footer>
  )
}

export default Footer
